(function(){
  function adaptBigSlide(){    
    var mh = Math.max(600,$(window).height())
    console.log("adaptBigSlide",mh);
    //$('.big-slide').css({"min-height": mh + 'px'}); 
    mh = ($(window).width() / 2880) * 1223;
    $('.big-slide').css({"min-height": mh + 'px'}); 
  }
  
  $(document).ready(function(){
  	adaptBigSlide();
  });
  
  $(window).resize(function(){
    adaptBigSlide();
  });
  
}())